import PublicPageNavbar from "./PublicPageNavbar";

const PublicPageTemplate = ({ children }) => {
    return (
        <>
            <PublicPageNavbar />
            <div className="public-page-template">
                {children}
            </div>
        </>
    );
};

export { PublicPageTemplate };